import React from "react";
import "../index.css";

import { Routes, Route, Navigate, Outlet } from "react-router-dom";

import ProtectedRoute from "./common/protectedRoute";

import Home from "./HomePages/Home/Home";
import Login from "./SignupnLogin/Login";
import SignUp from "./SignupnLogin/Signup";
import Logout from "./SignupnLogin/Logout";
import Welcome from "./OnboardingPages/Welcome";
import ThirdPartAuthSuccess from "./HomePages/HomeIntegrations/ThirdPartAuthSuccess";
import PaymentSuccess from "./PaymentPages.js/PaymentSuccess";

import { Dashboard } from "V2.0/HomePages/Dashboard";
import { KnowledgeBases, KnowledgeBase } from "./HomePages/Knowledge_base";
import { Contacts } from "./HomePages/Contacts";
import HomePrompt from "./HomePages/HomePrompt";
import HomeAPISettings from "./HomePages/HomeAPISettings";
import { Threads } from "./HomePages/Threads";

import { Integrations } from "./HomePages/Integrations";
import Whatsapp from "./HomePages/Integrations/Communications/Whatsapp";
import { MessengerIntegration } from "./HomePages/Integrations/Messenger";
import { TwilioIntegration } from "./HomePages/Integrations/Twilio";
import { S3Integration } from "./HomePages/Integrations/S3";
import { PineConeIntegration } from "./HomePages/Integrations/Pinecone";
import { ChromaDBIntegration } from "./HomePages/Integrations/ChromaDB";
// import HomeCampaigns from "V2.0/HomePages/HomeCampaign";
import Schedule from "V2.0/HomePages/HomeCampaign/Configuration";
import Modules from "./HomePages/Modules";
import { WebHooks } from "./HomePages/Modules/Webhooks";
import { CustomAPIs } from "./HomePages/HomeModule/CustomAPIs";
import { HumanAgentTransfer } from "./HomePages/Modules/Human_agents_transfer";
import { Extractions } from "./HomePages/Modules/Extractions";
import { Triggers } from "./HomePages/Modules/Triggers";
import { EndCall } from "./HomePages/Modules/End_call";
import PIIEncryptionComponent from "./HomePages/HomeModule/PIIEncryptionComponent";
import Recording from "./HomePages/HomeModule/Recording";
import VoiceEmbed from "./HomePages/HomeModule/VoiceEmbed";
import ChatEmbed from "./HomePages/HomeModule/ChatEmbed";
import AcuityCalendarScheduling from "./HomePages/HomeModule/Acuity";
import { GHLIntegration } from "./HomePages/Integrations/GHL";
import GHLCRM from "./HomePages/HomeModule/GHLCRM";
import ZohoCRM from "./HomePages/HomeModule/ZohoCRM";
import { ZohoCRMIntegration } from "./HomePages/Integrations/ZohoCRM";
import HomeBilling, { Billing } from "./HomePages/HomeBilling";
import ForgotPassword from "./SignupnLogin/ForgotPassword";
import ResetPassword from "./SignupnLogin/ResetPassword";
import { PlivoIntegration } from "./HomePages/Integrations/Plivo";
import { InstagramIntegration } from "./HomePages/Integrations/Instagram";

import { Assistants, Assistant } from "V2.0/HomePages/Assistants";
import { VoicesLibrary } from "V2.0/HomePages/VoicesLibrary";
import { AcuityScheduling } from "./HomePages/Integrations/Acuity";
import CalIntegration from "./HomePages/Integrations/Cal/Cal";

import { Workflows } from "./HomePages/Workflows";
import { Workflow } from "./HomePages/Workflows/Workflow";
import { Builder } from "./HomePages/Workflows/Builder";

import { MakeIntegration } from "./HomePages/Integrations/Make";
import { ZapierIntegration } from "./HomePages/Integrations/Zapier";

import { ConversationMessageView } from "./HomePages/Threads/components/conversation_messages";

import AccountProvider from "V2.0/Context/AccountContext";
import Account from "V2.0/Account";
import TeamInvite from "./SignupnLogin/TeamInvite";
import LogoutAgent from "./SignupnLogin/LogoutAgent";
import SetPassword from "./SignupnLogin/SetPassword";
import ThirdPartyProvider from "V2.0/Context/ThirdPartyContext";
import Campaigns from "V2.0/HomePages/Campaigns";

import MCubeIntegration from "V2.0/HomePages/Integrations/Telephony/MCube";
import CloudonixIntegration from "V2.0/HomePages/Integrations/Telephony/Cloudonix";
import CustomSIPIntegration from "V2.0/HomePages/Integrations/Telephony/CustomSIP";
import ExotelIntegration from "V2.0/HomePages/Integrations/Telephony/Exotel";
import TataSmartFloIntegration from "./HomePages/Integrations/Telephony/Tata";

import Settings from "V2.0/HomePages/Settings";

import AssistantsProvider from "V2.0/Context/AssistantsContext";
import IndexRoute from "V2.0/HomePages/Home/IndexRoute";
import AccessRoute from "V2.0/HomePages/Home/Sidebar/AccessRoute";

import Pipelines, {
  PipelineRedirectWithSearchParams,
} from "V2.0/HomePages/Pipelines";
import PipelinesV2 from "V2.0/HomePages/PipelinesV2";
import PipelineRunsV2 from "V2.0/HomePages/PipelinesV2/PipelineRunsV2";

function ProtectedRouteLayout() {
  return (
    <ProtectedRoute>
      <Outlet />
    </ProtectedRoute>
  );
}

function ProtectedRouteWithContext() {
  return (
    <ProtectedRoute>
      <AccountProvider>
        <ThirdPartyProvider>
          <AssistantsProvider>
            {/* <UsersProvider> */}
            <Outlet />
            {/* </UsersProvider> */}
          </AssistantsProvider>
        </ThirdPartyProvider>
      </AccountProvider>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div>
      <Routes>
        <Route
          path="/signup"
          element={<SignUp />}
        />
        <Route
          path="/login"
          element={<Login />}
        />
        <Route
          path="/forgot-password"
          element={<ForgotPassword />}
        />
        <Route
          path="/reset-password"
          element={<ResetPassword />}
        />
        <Route
          path="/team-invite"
          element={<TeamInvite />}
        />
        <Route
          path="/create-password"
          element={<SetPassword />}
        />
        <Route
          path="*"
          element={
            <Navigate
              to="/not-found"
              replace
            />
          }
        />

        <Route element={<ProtectedRouteWithContext />}>
          <Route
            path="/account"
            element={<Account />}
          />
          <Route
            path="/logout"
            element={<Logout />}
          />
          <Route
            path="/logout-agent"
            element={<LogoutAgent />}
          />
          <Route
            path="/welcome"
            element={<Welcome />}
          />
          <Route
            path="/onboarding/:companyId"
            element={<Welcome />}
          />
          <Route
            path="/oauth/callback"
            element={<ThirdPartAuthSuccess />}
          />
          <Route
            path="/success/:sessionId?"
            element={<PaymentSuccess />}
          />
          <Route element={<Home />}>
            <Route
              index
              path="/"
              element={<IndexRoute />}
            />
            <Route element={<AccessRoute />}>
              <Route
                path="dashboard"
                element={<Dashboard />}
              />
              <Route
                path="assistants"
                element={<Assistants />}
              />
              <Route
                path="assistants/:assistantId"
                element={<Assistant />}
              />
              <Route
                path="knowledgebases"
                element={<KnowledgeBases />}
              />
              <Route
                path="knowledgebases/:knowledgebaseId"
                element={<KnowledgeBase />}
              />

              <Route
                path="threads"
                element={<Threads />}
              >
                <Route
                  path=":conversationId"
                  element={<ConversationMessageView />}
                />
              </Route>
              <Route
                path="contacts"
                element={<Contacts />}
              />
              <Route
                path="campaign"
                element={<Campaigns />}
              />
              <Route
                path="pipelines"
                element={<Pipelines />}
              >
                <Route
                  index
                  element={<PipelineRedirectWithSearchParams />}
                />
                <Route
                  path="v1"
                  element={<Workflows />}
                />
                <Route
                  path="v2"
                  element={<PipelinesV2 />}
                />

                <Route
                  path="v2/:id"
                  element={<PipelineRunsV2 />}
                />
                <Route
                  path="v1/:id"
                  element={<Workflow />}
                />
              </Route>
              <Route
                path="pipelines/:id/edit"
                element={<Builder />}
              />
              <Route
                path="settings"
                element={<Settings />}
              />
              <Route
                path="integrations"
                element={<Integrations />}
              />
              <Route
                path="billing"
                element={<Billing />}
              />

              <Route
                path="integrations/plivo"
                element={<PlivoIntegration />}
              />
              <Route
                path="integrations/whatsapp"
                element={<Whatsapp />}
              />
              <Route
                path="integrations/messenger"
                element={<MessengerIntegration />}
              />
              <Route
                path="/integrations/instagram"
                element={<InstagramIntegration />}
              />
              <Route
                path="integrations/make"
                element={<MakeIntegration />}
              />
              <Route
                path="integrations/zapier"
                element={<ZapierIntegration />}
              />

              <Route
                path="integrations/ghl"
                element={<GHLIntegration />}
              />
              <Route
                path="integrations/zoho-crm"
                element={<ZohoCRMIntegration />}
              />
              <Route
                path="integrations/acuity"
                element={<AcuityScheduling />}
              />

              <Route
                path="integrations/twilio"
                element={<TwilioIntegration />}
              />
              <Route
                path="integrations/s3"
                element={<S3Integration />}
              />
              <Route
                path="integrations/pinecone"
                element={<PineConeIntegration />}
              />
              <Route
                path="integrations/chromadb"
                element={<ChromaDBIntegration />}
              />
              <Route
                path="integrations/cal"
                element={<CalIntegration />}
              />

              <Route
                path="integrations/mcube"
                element={<MCubeIntegration />}
              />
              <Route
                path="integrations/cloudonix"
                element={<CloudonixIntegration />}
              />
              <Route
                path="integrations/custom-sip"
                element={<CustomSIPIntegration />}
              />

              <Route
                path="integrations/exotel"
                element={<ExotelIntegration />}
              />

              <Route
                path="integrations/tata-smartflo"
                element={<TataSmartFloIntegration />}
              />

              <Route
                path="/voiceslibrary"
                element={<VoicesLibrary />}
              />
            </Route>
          </Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
